export default __webpack_public_path__ + "static/media/Custom.c4b8723c.jpg";